import { useState } from 'react';
import { useApplicationCore } from './useApplicationCore';
import { useApplicationEdit } from './useApplicationEdit';
import { useApplicationDocuments } from './useApplicationDocuments';
import { useApplicationAI } from './useApplicationAI';
import { useApplicationLoan } from './useApplicationLoan';

/**
 * Main hook for the application detail page.
 * Composes 5 domain-specific sub-hooks into a single interface consumed by CRMApplicationDetail.
 */
export function useApplicationDetail() {
  const core = useApplicationCore();
  const { id, application, saving, setSaving, loadApplication } = core;

  // Modal visibility state (cross-cutting UI concerns not tied to any single domain)
  const [showAIAssistant, setShowAIAssistant] = useState(false);
  const [showEmailTemplates, setShowEmailTemplates] = useState(false);
  const [showDocumentTemplates, setShowDocumentTemplates] = useState(false);
  const [showDocumentGenerator, setShowDocumentGenerator] = useState(false);
  const [showClientLinkModal, setShowClientLinkModal] = useState(false);
  const [showMarketingGenerator, setShowMarketingGenerator] = useState(false);

  const edit = useApplicationEdit({ id, application, setSaving, loadApplication });
  const docs = useApplicationDocuments({ id, application, setSaving, loadApplication });
  const ai = useApplicationAI({ id, loadApplication });
  const loan = useApplicationLoan({ id, application, loadApplication });

  return {
    // Core
    ...core,
    // Modals
    showAIAssistant, setShowAIAssistant,
    showEmailTemplates, setShowEmailTemplates,
    showDocumentTemplates, setShowDocumentTemplates,
    showDocumentGenerator, setShowDocumentGenerator,
    showClientLinkModal, setShowClientLinkModal,
    showMarketingGenerator, setShowMarketingGenerator,
    // Edit
    ...edit,
    // Documents
    ...docs,
    // AI
    ...ai,
    // Loan
    ...loan,
  };
}
